"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPageDurations = void 0;
/**
 * Tracks the page durations of when the user is on the page. When the user
 * leaves the current page (either by unfocusing or going to another page),
 * we record a page_left event with the total time that the user spent on
 * the page.
 *
 * @param track The function we should call to trigger an event call
 * @returns
 */
function trackPageDurations(track) {
    var currentPageView = null;
    // handles when the user leaves a page or unfocuses the page
    var handleLeavePage = function () {
        if (!currentPageView) {
            return;
        }
        var duration = Math.round((Date.now() - currentPageView.timeOpened) / 1000);
        if (duration === 0) {
            // ignore <500ms duration views (e.g. redirects)
            return;
        }
        track('page_left', {
            path: currentPageView === null || currentPageView === void 0 ? void 0 : currentPageView.path,
            duration: duration,
        });
        currentPageView = null;
    };
    // handles when the user enters a new page or focuses the page again
    var handleEnterPage = function () {
        var pathname = window.location.pathname;
        currentPageView = {
            path: pathname,
            timeOpened: Date.now(),
        };
    };
    window.addEventListener('focus', handleEnterPage);
    window.addEventListener('blur', handleLeavePage);
    window.addEventListener('unload', handleLeavePage);
    // handle enter page on initialize
    if (document.hasFocus()) {
        handleEnterPage();
    }
    return {
        page: function () {
            handleLeavePage();
            handleEnterPage();
        },
        unsubscribe: function () {
            window.removeEventListener('focus', handleEnterPage);
            window.removeEventListener('blur', handleLeavePage);
            window.removeEventListener('unload', handleLeavePage);
        },
    };
}
exports.trackPageDurations = trackPageDurations;
//# sourceMappingURL=durationTracker.js.map